import { Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DashboardHeader from "../../../components/dashboard/dashboardHeader";
import { TimeRegistrationTab } from "../../../components/dashboard/projects/tabs/time-registration-tab";
import { useCanViewHoursCompanyOverview } from "../../../routes/roleOnly";

export const HoursCompanyOverview = () => {
  const { t } = useTranslation();
  const allowed = useCanViewHoursCompanyOverview();

  if (!allowed) {
    return <Navigate to="/dashboard/hours" replace />;
  }

  return (
    <>
      <DashboardHeader
        title={t("hours.company_overview", "Timeoversikt")}
        subtitle={t(
          "hours.company_overview.subtitle",
          "Alle timer i valgt måned. Filtrer på prosjekt, aktivitet, ansatte og avdeling. Estimat for kostnad og salg."
        )}
      />
      <div className="px-4 py-4 sm:px-6">
        <TimeRegistrationTab
          project={null}
          companyScope
          canManageProjectTime={false}
          showHourlyCosts
        />
      </div>
    </>
  );
};
